import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import CancelSalesModal from '../../../../views/order/common/modal/CancelSalesModal';
import { orderActions } from '../../../../store/modules/order';
import { ORDER_ITEM_CANCEL_SALES_TYPE } from '../../../../constants/service/app/orderConstants';
import withModal from '../../../../lib/hoc/withModal';

class CancelSalesModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  판매 취소 사유타입
       */
      reasonType: ORDER_ITEM_CANCEL_SALES_TYPE.DELIVERY_DELAY,
      /**
       *  판매 취소 상세사유
       */
      reason: null,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'cancelSalesModal',
    });
  };

  /**
   * 판매 취소하기
   */
  onSubmit = () => {
    const { form, data, getCancelOrderManagementInfoList } = this.props;
    const { orderItemIdList } = data;
    const { reasonType, reason } = this.state;

    form.validateFields((err) => {
      if (err) return;

      getCancelOrderManagementInfoList({
        orderItemIdList,
        reasonType,
        reason,
      });

      this.closeModal();
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    const { isOpen, form } = this.props;

    return (
      <CancelSalesModal
        form={form}
        isOpen={isOpen}
        {...this.state}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.cancelSalesModal.isOpen,
    data: state.order.cancelSalesModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  getCancelOrderManagementInfoList: orderActions.getCancelOrderManagementInfoList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(CancelSalesModalContainer)));
